import {
  CONFIDENTIALITY_PARENT,
  CONFIDENTIALITY_STATUS,
  DEFAULT_ITEMS_DIVIDER,
} from "./constants";

/** @returns {boolean} */
export const isTemplateTwoPageVisible = (value, defaultWhenMissing = true) => {
  if (value === undefined || value === null) return defaultWhenMissing;
  return value === true || value === 1 || value === "true" || value === "1";
};

export const DEFAULT_TEMPLATE_TWO_PAGES = {
  cover: {
    show: true,
    showCompanyName: true,
    showQuotationNo: true,
    showClientName: true,
    showQuotationTitle: true,
    showSalesRef: true,
    /** Toggles the large centred photo under the cover copy. */
    showImage: true,
    /** File or URL of the cover photo (falls back to the company logo when empty). */
    image: "",
    showImageBorder: false,
  },
  intro: {
    show: true,
    showConfidentialityRow: true,
    confidentialityParent: CONFIDENTIALITY_PARENT,
    confidentialityStatus: CONFIDENTIALITY_STATUS,
    introBodyOverride: "",
    restrictionBodyOverride: "",
    showCompanyName: true,
    showAddress: true,
    showMobile: true,
    showProposalManager: true,
    showEmail: true,
    showSlogan: true,
    sloganText: "",
    /** Optional site/project image shown at the bottom of the page. */
    image: "",
    /** Caption printed under the site/project image. */
    imageCaption: "",
  },
  items: {
    show: true,
    dividerText: DEFAULT_ITEMS_DIVIDER,
    showTerms: true,
    termsDividerText: "Terms & Conditions",
  },
};

const parseMaybeJson = (value, depth = 0) => {
  if (typeof value !== "string") return value;

  const trimmed = value.trim();
  if (!trimmed || !["{", "[", '"'].includes(trimmed[0])) return value;

  try {
    const parsed = JSON.parse(trimmed);
    return typeof parsed === "string" && depth < 1 ? parseMaybeJson(parsed, depth + 1) : parsed;
  } catch {
    return value;
  }
};

const asPlainObject = (value) => {
  const parsed = parseMaybeJson(value);
  return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
};

/**
 * Merges saved `configs.pages` with Template 3 defaults (API may omit keys).
 */
export const mergeTemplateTwoPages = (pagesFromConfig = {}) => {
  const pages = asPlainObject(pagesFromConfig);

  return {
    cover: { ...DEFAULT_TEMPLATE_TWO_PAGES.cover, ...asPlainObject(pages.cover) },
    intro: { ...DEFAULT_TEMPLATE_TWO_PAGES.intro, ...asPlainObject(pages.intro) },
    items: { ...DEFAULT_TEMPLATE_TWO_PAGES.items, ...asPlainObject(pages.items) },
  };
};
